/* Workspace (mobile-web) — shared i18n + helpers. Mirrors MOBILE_AGENT_PROMPT_ORG_WORKSPACE.md */

export const WTXT = {
  en: {
    ws_title: 'Workspace', personal: 'Personal', switch_personal: 'Personal',
    invitations: 'Invitations', accept: 'Accept', reject: 'Reject',
    invited_by: 'Invited by', expires: 'Expires',
    inv_accepted: 'Invitation accepted', inv_rejected: 'Invitation rejected',
    your_orgs: 'Your organisations',
    no_orgs_title: 'No workspaces yet',
    no_orgs_body: 'When an organisation invites you as an admin, moderator or revisor, it appears here.',
    role_owner: 'Owner', role_admin: 'Admin', role_moderator: 'Moderator', role_revisor: 'Revisor',
    divisions: 'divisions', events: 'events', whole_org: 'Whole organisation',
    back: 'Back', loading: 'Loading…', error_load: 'Could not load data', no_data: 'No data',
    kpi_collected: 'Total collected', kpi_tx: 'Transactions', kpi_avg: 'Avg. payment', kpi_payers: 'Unique payers',
    range_7d: 'Last 7 days', range_30d: 'Last 30 days', range_90d: 'Last 90 days',
    all_divisions: 'All divisions', by_division: 'By division', export_csv: 'Export CSV',
    view_only: 'View-only on mobile — manage your organisation on the web dashboard',
    open_erp: 'Open web dashboard',
    my_scope: 'My divisions & events',
    live_tally: 'Live tally', total_collected: 'Collected (all time)', today: 'Today', payments: 'payments',
    registrations: 'Registrations', no_registrations: 'No payments yet', guest: 'Guest',
    qr_title: 'Payment QR', share: 'Share', copy_link: 'Copy link', copied: 'Link copied',
    nested: 'Nested events', division: 'Division', event: 'Event',
    new_event: 'New event', edit: 'Edit', appoint_moderator: 'Appoint moderator',
    payout_swish: 'Payout Swish', payout_locked: 'Locked by the owner', select_swish: 'Select payout account',
    save: 'Save', cancel: 'Cancel', name: 'Name', description: 'Description',
    email: 'Email', phone: 'Phone', display_name: 'Display name (optional)', send_invite: 'Send invitation',
    invited: 'Invitation sent', saved: 'Saved', event_created: 'Event created',
    email_or_phone_required: 'Enter an email or phone number', primary: 'Primary',
    admin_tools: 'Admin tools',
    default_message: 'Default message', default_message_hint: 'Shown to payers on the QR page',
    require_guest_details: 'Require guest name and phone',
    require_guest_details_hint: 'When off, guests can pay without entering name or phone',
    fixed_amount: 'Fixed amount (SEK)', optional: 'optional',
    invalid_amount: 'Amount must be a positive number',
    inherits_from_parent: 'Inherits from parent',
    payout_locked_hint: 'The payout Swish is set by the org owner and cannot be changed here.',
    download_flyer: 'Flyer', flyer_downloaded: 'Flyer downloaded',
    payment_type: 'Payment type', amount_mode: 'Amount', line_items_mode: 'Items menu',
    add_item: 'Add item', item_description: 'Item name', item_amount: 'Price (SEK)',
    max_items_reached: 'Maximum 4 items', line_items_required: 'Add at least one item',
    name_required: 'Please enter a name',
  },
  sv: {
    ws_title: 'Arbetsyta', personal: 'Personligt', switch_personal: 'Personligt',
    invitations: 'Inbjudningar', accept: 'Acceptera', reject: 'Avböj',
    invited_by: 'Inbjuden av', expires: 'Går ut',
    inv_accepted: 'Inbjudan accepterad', inv_rejected: 'Inbjudan avböjd',
    your_orgs: 'Dina organisationer',
    no_orgs_title: 'Inga arbetsytor ännu',
    no_orgs_body: 'När en organisation bjuder in dig som admin, moderator eller revisor visas den här.',
    role_owner: 'Ägare', role_admin: 'Admin', role_moderator: 'Moderator', role_revisor: 'Revisor',
    divisions: 'divisioner', events: 'event', whole_org: 'Hela organisationen',
    back: 'Tillbaka', loading: 'Laddar…', error_load: 'Kunde inte ladda data', no_data: 'Ingen data',
    kpi_collected: 'Totalt insamlat', kpi_tx: 'Transaktioner', kpi_avg: 'Snittbetalning', kpi_payers: 'Unika betalare',
    range_7d: 'Senaste 7 dagarna', range_30d: 'Senaste 30 dagarna', range_90d: 'Senaste 90 dagarna',
    all_divisions: 'Alla divisioner', by_division: 'Per division', export_csv: 'Exportera CSV',
    view_only: 'Endast visning på mobilen — hantera din organisation i webbpanelen',
    open_erp: 'Öppna webbpanelen',
    my_scope: 'Mina divisioner & event',
    live_tally: 'Live-räkning', total_collected: 'Insamlat (totalt)', today: 'Idag', payments: 'betalningar',
    registrations: 'Registreringar', no_registrations: 'Inga betalningar ännu', guest: 'Gäst',
    qr_title: 'Betalnings-QR', share: 'Dela', copy_link: 'Kopiera länk', copied: 'Länk kopierad',
    nested: 'Nästlade event', division: 'Division', event: 'Event',
    new_event: 'Nytt event', edit: 'Redigera', appoint_moderator: 'Utse moderator',
    payout_swish: 'Utbetalnings-Swish', payout_locked: 'Låst av ägaren', select_swish: 'Välj utbetalningskonto',
    save: 'Spara', cancel: 'Avbryt', name: 'Namn', description: 'Beskrivning',
    email: 'E-post', phone: 'Telefon', display_name: 'Visningsnamn (valfritt)', send_invite: 'Skicka inbjudan',
    invited: 'Inbjudan skickad', saved: 'Sparat', event_created: 'Event skapat',
    email_or_phone_required: 'Ange e-post eller telefonnummer', primary: 'Primärt',
    admin_tools: 'Adminverktyg',
    default_message: 'Standardmeddelande', default_message_hint: 'Visas för betalare på QR-sidan',
    require_guest_details: 'Kräv gästens namn och telefon',
    require_guest_details_hint: 'Av: gäster kan betala utan att ange namn eller telefon',
    fixed_amount: 'Fast belopp (SEK)', optional: 'valfritt',
    invalid_amount: 'Beloppet måste vara positivt',
    inherits_from_parent: 'Ärvs från förälder',
    payout_locked_hint: 'Utbetalnings-Swishen sätts av ägaren och kan inte ändras här.',
    download_flyer: 'Affisch', flyer_downloaded: 'Affisch nedladdad',
    payment_type: 'Betalningstyp', amount_mode: 'Belopp', line_items_mode: 'Artikelmeny',
    add_item: 'Lägg till artikel', item_description: 'Artikelnamn', item_amount: 'Pris (SEK)',
    max_items_reached: 'Max 4 artiklar', line_items_required: 'Lägg till minst en artikel',
    name_required: 'Ange ett namn',
  },
};

export const wsErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d?.message) return d.message;
  return 'Error';
};

export const roleLabel = (role, t) =>
  ({ owner: t.role_owner, admin: t.role_admin, moderator: t.role_moderator, revisor: t.role_revisor }[role] || role);

export const ROLE_CLS = {
  owner: 'bg-amber-50 text-amber-800 border-amber-200',
  admin: 'bg-teal-50 text-teal-700 border-teal-200',
  moderator: 'bg-sky-50 text-sky-700 border-sky-200',
  revisor: 'bg-violet-50 text-violet-700 border-violet-200',
};

export function RoleChip({ role, t }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${ROLE_CLS[role] || 'bg-slate-100 text-slate-600 border-slate-200'}`}>
      {roleLabel(role, t)}
    </span>
  );
}

export function downloadCsv(csvData, filename) {
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
